import React from 'react'

const Gainers = () => {
  return (
    <div>Gainers</div>
  )
}

export default Gainers